import React from "react";
import { Link } from "react-router-dom";

const SouthernGroundHornbill = "/Images/SouthernGroundHornbill.png";

const SouthernGroundedHornbill = () => {
  return (
    <>
    <section
      className="vh-100 position-relative"
      style={{
        backgroundImage: `url(${SouthernGroundHornbill})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "linear-gradient(rgba(0,0,0,.15), rgba(0,0,0,.45))"
        }}
      />

      <div className="container-fluid h-100 position-relative">
        <div className="row h-100 align-items-center">
          <div className="col-lg-7 col-md-9">

            <div
              className="text-white"
              style={{
                marginLeft: "40px",
                marginTop: "80px"
              }}
            >
              <div className="d-flex align-items-center gap-2 mb-3">

                <small
                  className="fw-semibold"
                  style={{
                    letterSpacing: "1px"
                  }}
                >
                  ← All Species
                </small>

                <span
                  className="badge bg-danger px-3 py-2"
                  style={{
                    fontSize: "9px",
                    letterSpacing: "1px"
                  }}
                >
                  ENDANGERED
                </span>

              </div>

              <h1
                className="fw-normal mb-4"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "5rem",
                  lineHeight: ".95"
                }}
              >
                Southern Ground
                <br />
                Hornbill
              </h1>

              <p
                className="fst-italic mb-4"
                style={{
                  fontSize: "18px",
                  color: "rgba(255,255,255,.85)"
                }}
              >
                Bucorvus leadbeateri · Open savanna &
                woodland · Sub-Saharan Africa
              </p>

              <hr
                className="border-light opacity-75"
                style={{
                  width: "520px"
                }}
              />

              <div className="d-flex gap-5 mt-4">

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    1,500
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                    Left In South Africa
                  </small>
                </div>

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    70%
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                    Range Declined
                  </small>
                </div>

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    7
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                    Major Threats
                  </small>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </section>

    <section
  className="py-5"
  style={{
    background: "#f5f3ee"
  }}
>
  <div
    className="container"
    style={{
      maxWidth: "1100px"
    }}
  >
    <div className="row g-5">

      {/* LEFT SIDEBAR */}

      <div className="col-lg-3">

        <div
          className="p-4 mb-4"
          style={{
            background: "#ece9e2"
          }}
        >
          <h6
            style={{
              fontFamily: "Georgia, serif"
            }}
          >
            Support This Work
          </h6>

          <p
            className="small text-muted"
          >
            Field research, community programs, and habitat
            protection all depend on donations.
          </p>

          <button
            className="btn w-100 text-white rounded-0"
            style={{
              background: "#6d735d"
            }}
          >
            <Link to="/donate" style={{ textDecoration: "none", color: "white" }}>
              DONATE
            </Link>
          </button>
        </div>

        <small
          className="text-uppercase text-muted"
          style={{
            fontSize: "10px",
            letterSpacing: "2px"
          }}
        >
          Related Articles
        </small>

        <div className="border-top py-3">
          <Link to="/african-penguin" className="text-decoration-none text-dark">
                   
          <div>African Penguin →</div>
          </Link>
          <small className="text-muted">
            Critically Endangered
          </small>
        </div>

        <div className="border-top py-3">
          <Link to="/bearded-vulture" className="text-decoration-none text-dark">
                   
          <div>Bearded Vulture →</div>
          </Link>
          <small className="text-muted">
            Endangered
          </small>
        </div>

        <div className="border-top py-3">
          <Link to="/pels-fishing-owl" className="text-decoration-none text-dark">
                   
          <div>Pel's Fishing Owl →</div>
          </Link>
          <small className="text-muted">
            Vulnerable
          </small>
        </div>

      </div>

      {/* MAIN CONTENT */}

      <div className="col-lg-9">

        <div className="row mb-5">

          <div className="col-lg-7">
            <p
              className="text-secondary"
              style={{
                lineHeight: "2",
                fontSize: "14px"
              }}
            >
              The Southern Ground Hornbill is Africa’s largest hornbill  a slow-
walking, jet-black giant with a blazing red face and a booming
dawn call that carries for miles across open savanna. They live in
cooperative family groups and have been part of African ecosystems
for millennia. Right now, in South Africa, fewer than 1,500 remain.
            </p>
          </div>

          <div className="col-lg-5">

            <div className="row text-center" style={{
          fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "17px",
          fontWeight: 600,
          marginBottom: "4px",
          lineHeight: 1.3,
        }}>

              <div className="col-4" >
                <p>5–13 lb</p>
                <small  style={{
                   color: "#888",
                }}>Average Weight</small>
              </div>

              <div className="col-4">
                <p>35–50 in</p>
                <small  style={{
                   color: "#888",
                }}>Average Height</small>
              </div>

              <div className="col-4">
                <p>7</p>
                <small  style={{
                   color: "#888",
                }}>Average Lifespan</small>
              </div>

            </div>

          </div>

        </div>

        {/* PERSONAL NOTE */}

        <div
          className="bg-white p-4 mb-4 border-start border-warning border-3"
        >
          <small
            className="text-uppercase text-warning fw-bold"
          >
            A Personal Note
          </small>

          <p
            className="fst-italic mt-3 mb-0"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "18px"
            }}
          >
            ""I first saw a Southern Ground Hornbill when I was twelve  an enormous,
deliberate bird, walking through the grass in Kruger like it had been doing 
so for a thousand years. That single moment is what started all of this.""
          </p>
        </div>

        {/* STATUS */}

        <div
          className="text-white p-4 mb-5"
          style={{
            background: "#6d735d"
          }}
        >
          <small
            className="text-uppercase"
            style={{
              letterSpacing: "2px"
            }}
          >
            Conservation Status
          </small>

          <p className="mb-0 mt-2">
           The Southern Ground Hornbill is listed as Vulnerable globally by the IUCN, and has been uplisted to Endangered in South Africa, Lesotho, Namibia, and Eswatini. A decline of 30–49% across their range is projected over the next 94 years if current threats continue.
          </p>
        </div>

        {/* TROUBLE */}

        <h2
          className="mb-5"
          style={{
            fontFamily: "Georgia, serif"
          }}
        >
          Why This Species Is In Trouble
        </h2>

        <div className="position-relative mb-5">

          <div
            className="position-absolute"
            style={{
              left: "4px",
              top: 0,
              bottom: 0,
              width: "1px",
              background: "#ddd"
            }}
          />

          {[
            {
              title: "Habitat Loss & Fragmentation",
              text: "The single greatest threat. These birds need vast, unbroken stretches of savannato survive and that land is being carved up by agricultureSouth Africa’s protected reserves, they’ve essentially vanished."
            },
            {
              title: "Poisoning",
              text: "Hornbills see their reflection in windows and attack the glass frustratinglandowners who sometimes retaliate with poison. Secondary poisoning isequally deadly: lead ammunition in carcasses, rat poison set for other animalsall of it kills hornbills that had nothing to do with the original target."
            },
            {
              title: "Hunting For Traditional Medicine",
              text: "Across their range, hornbills are hunted for use in traditional rituals. In somecommunities they're seen as omens of death; in others, protectors against evilspirits. This complex cultural relationship means conservation can’t workwithout genuine community partnership."
            },
            {
              title: "Electrocution",
              text: "As power infrastructure spreads across rural Africa, large birds like hornbillsincreasingly die on transformer boxes and high-tension lines. It’s a slow, quiettoll one bird at a time that’s nearly impossible to track."
            }
          ].map((item, index) => (
            <div
              className="d-flex mb-5"
              key={index}
            >
              <div
                className="rounded-circle me-4 mt-2"
                style={{
                  width: "8px",
                  height: "8px",
                  background: "#c98d2c",
                  zIndex: 2
                }}
              />

              <div>
                <h6
                  style={{
                    fontFamily: "Georgia, serif"
                  }}
                >
                  {item.title}
                </h6>

                <p
                  className="text-muted"
                  style={{
                    fontSize: "13px",
                    lineHeight: "1.8"
                  }}
                >
                  {item.text}
                </p>
              </div>
            </div>
          ))}

        </div>

        {/* QUOTE */}

        <div
          className="text-white p-5 my-5"
          style={{
            background: "#6d735d"
          }}
        >
          <div
            style={{
              fontSize: "40px",
              color: "#e0b04b"
            }}
          >
            "
          </div>

          <p
            className="fst-italic mb-0"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "24px"
            }}
          >
            Once a territory is lost as a nesting site,
            a pair may not breed again for years.
          </p>
        </div>

        {/* ACTIONS */}

        <h2
          className="mb-4"
          style={{
            fontFamily: "Georgia, serif"
          }}
        >
          We're supporting the following activities
        </h2>

        <div className="d-flex flex-column gap-2 mb-5">

          {[
            "Captive breeding and managed release programs across South Africa",
            "Community education in rural villages bordering hornbill territories",
            "Collaborating with farmers to prevent persecution incidents",
            "Installing artificial nest boxes where old trees have been lost"
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white border px-3 py-3"
            >
              <span
                className="me-2"
                style={{
                  color: "#c98d2c"
                }}
              >
                ○
              </span>

              {item}
            </div>
          ))}

        </div>

        {/* IMAGE BLOCK */}

        <div
          className="p-4 text-white"
          style={{
            background: "#6d735d"
          }}
        >
          <small
            className="text-uppercase"
            style={{
              letterSpacing: "2px"
            }}
          >
            Reasons For Hope
          </small>

          <p className="mt-2">
            The Mabula Ground-Hornbill Project is raising captive-bred birds and releasing them into
the wild. Nest monitoring programs and community custodianship are gaining ground 
but the urgency is real.
          </p>

          <img
            src="/Images/SouthernGroundHornbill2.png"
            alt=""
            className="img-fluid w-100"
          />
        </div>

      </div>

    </div>
  </div>
</section>
    
    </>
  );
};

export default SouthernGroundedHornbill;